// @noflow
import { ClickableArea, CloseButton, CrossPath, Overlay, PopupContainer, ScaleGroup } from './style';
import { getPopupButtonHeight, getPopupSize } from '../utils';

import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

Popup.propTypes = {
    height: PropTypes.number.isRequired,
    hidePopup: PropTypes.func.isRequired,
    isPreviousDayEvent: PropTypes.bool.isRequired,
    numEventsInSelectedDay: PropTypes.number.isRequired,
    selectedDay: PropTypes.number.isRequired,
    selectedEvent: ImmutablePropTypes.contains({
        eventIndex: PropTypes.number.isRequired,
        start: PropTypes.number.isRequired
    }).isRequired,
    selectedEventDuration: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
};

export default function Popup({
    height,
    hidePopup,
    isPreviousDayEvent,
    numEventsInSelectedDay,
    selectedDay,
    selectedEvent,
    selectedEventDuration,
    width
}) {
    const popupWidth = getPopupSize(height);
    const buttonHeight = getPopupButtonHeight(height);
    const pathPoint = buttonHeight * 0.12;
    const popupHeight = popupWidth + buttonHeight;

    return (
        <g>
            <Overlay height={height} onClick={hidePopup} width={width} />
            <g transform={`translate(${width / 2} ${height / 2})`}>
                <ScaleGroup>
                    <PopupContainer r={popupHeight / 2} x={-popupWidth / 2} y={-popupHeight / 2} />
                    <g
                        onClick={hidePopup}
                        style={{
                            transform: `translate3d(0, ${popupWidth / 2.5}px, 0)`
                        }}
                        transform={`translate(0 ${popupWidth / 2.5})`}
                    >
                        <CloseButton data-qa="popup-close" r={buttonHeight * 0.3} />
                        <g transform={`translate(${-pathPoint * 0.5} 0)`}>
                            <CrossPath d={`M ${-pathPoint} 0 l ${pathPoint} ${pathPoint}`} />
                            <CrossPath d={`M 0 ${pathPoint} l ${2 * pathPoint} ${2 * -pathPoint}`} />
                        </g>
                        <ClickableArea r={buttonHeight * 0.5} />
                    </g>
                </ScaleGroup>
            </g>
        </g>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/popup/component.js